/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MFiends, MFiendsInterface } from "../MFiends";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IMGear",
        name: "_mineableGear",
        type: "address",
      },
      {
        internalType: "contract IOnChainPixelArtv2",
        name: "_onChainPixelArt",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_difficulty",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "X",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "Y",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "affinityToColor",
    outputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "affinityToName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "player",
        type: "address",
      },
    ],
    name: "assertValidGear",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "assets",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "layerIds",
        type: "uint256[]",
      },
    ],
    name: "composeLayers",
    outputs: [
      {
        internalType: "uint256[]",
        name: "composed",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ruinItemId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "guardItemId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "vigorItemId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "celerityItemId",
        type: "uint256",
      },
    ],
    name: "equipItems",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "equipped",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "equippedBy",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "game",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint64",
            name: "ruin",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "guard",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "vigor",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "celerity",
            type: "uint64",
          },
        ],
        internalType: "struct MFiends.Stats",
        name: "challenger",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint64",
            name: "ruin",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "guard",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "vigor",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "celerity",
            type: "uint64",
          },
        ],
        internalType: "struct MFiends.Stats",
        name: "enemy",
        type: "tuple",
      },
    ],
    name: "executeGame",
    outputs: [
      {
        internalType: "bool",
        name: "result",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seed",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint64",
            name: "ruin",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "guard",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "vigor",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "celerity",
            type: "uint64",
          },
        ],
        internalType: "struct MFiends.Stats",
        name: "challenger",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "affinity",
        type: "uint256",
      },
    ],
    name: "generateEnemy",
    outputs: [
      {
        components: [
          {
            internalType: "uint64",
            name: "ruin",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "guard",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "vigor",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "celerity",
            type: "uint64",
          },
        ],
        internalType: "struct MFiends.Stats",
        name: "enemy",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenData",
        type: "uint256",
      },
    ],
    name: "getAffinity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getAttributes",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getCharacteristicsData",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "getEquippedItems",
    outputs: [
      {
        internalType: "uint256[4]",
        name: "gear",
        type: "uint256[4]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMajorType",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMajorValue",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorType1",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorType2",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorValue1",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorValue2",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenData",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "affinity",
        type: "uint256",
      },
    ],
    name: "getPalette",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint64",
            name: "ruin",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "guard",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "vigor",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "celerity",
            type: "uint64",
          },
        ],
        internalType: "struct MFiends.Stats",
        name: "charStats",
        type: "tuple",
      },
    ],
    name: "getPowerLevel",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getStatsFromToken",
    outputs: [
      {
        components: [
          {
            internalType: "uint64",
            name: "ruin",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "guard",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "vigor",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "celerity",
            type: "uint64",
          },
        ],
        internalType: "struct MFiends.Stats",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint96",
        name: "nonce",
        type: "uint96",
      },
      {
        internalType: "bool",
        name: "callForHelp",
        type: "bool",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToTiers",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenData",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "palette",
        type: "uint256[]",
      },
      {
        internalType: "string",
        name: "backgroundColor",
        type: "string",
      },
    ],
    name: "renderData",
    outputs: [
      {
        internalType: "string",
        name: "svg",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenTraits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "paletteData",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "affinity",
        type: "uint256",
      },
    ],
    name: "renderFiend",
    outputs: [
      {
        internalType: "string",
        name: "svg",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "renderTokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stats",
    outputs: [
      {
        internalType: "uint64",
        name: "ruin",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "guard",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "vigor",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "celerity",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tierToStatBase",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "traits",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MFiends__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _mineableGear: string,
    _onChainPixelArt: string,
    _difficulty: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MFiends> {
    return super.deploy(
      _mineableGear,
      _onChainPixelArt,
      _difficulty,
      overrides || {}
    ) as Promise<MFiends>;
  }
  getDeployTransaction(
    _mineableGear: string,
    _onChainPixelArt: string,
    _difficulty: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _mineableGear,
      _onChainPixelArt,
      _difficulty,
      overrides || {}
    );
  }
  attach(address: string): MFiends {
    return super.attach(address) as MFiends;
  }
  connect(signer: Signer): MFiends__factory {
    return super.connect(signer) as MFiends__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MFiendsInterface {
    return new utils.Interface(_abi) as MFiendsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MFiends {
    return new Contract(address, _abi, signerOrProvider) as MFiends;
  }
}
